var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.693,
    height: 20.73,
    viewBox: "0 0 19.693 20.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Language",
    d: "M14.423,7.182H15.46A1.038,1.038,0,0,1,16.5,8.219V9.255a1.036,1.036,0,0,0,2.073,0V8.219A3.113,3.113,0,0,0,15.46,5.109H14.423a1.036,1.036,0,1,0,0,2.073ZM10.277,16.51H9.241A1.038,1.038,0,0,1,8.2,15.474V14.438a1.036,1.036,0,1,0-2.073,0v1.036a3.113,3.113,0,0,0,3.109,3.109h1.036a1.036,1.036,0,1,0,0-2.073Zm11.4-1.036a1.036,1.036,0,0,0,0-2.073H18.569v-.518a1.036,1.036,0,1,0-2.073,0V13.4H13.387a1.036,1.036,0,0,0,0,2.073H18.76a6.973,6.973,0,0,1-1.27,2.619,6.912,6.912,0,0,1-.652-1.019,1.036,1.036,0,0,0-1.844.945,8.994,8.994,0,0,0,.994,1.522,6.86,6.86,0,0,1-2.513,1.139,1.037,1.037,0,1,0,.442,2.025,8.95,8.95,0,0,0,3.571-1.681,9.042,9.042,0,0,0,3.6,1.68,1.036,1.036,0,0,0,.446-2.024,6.97,6.97,0,0,1-2.535-1.13,9.055,9.055,0,0,0,1.878-4.077ZM9.272,11.58a1.037,1.037,0,1,0,2.011-.5L9.461,3.791a2.364,2.364,0,0,0-4.587,0L3.053,11.077a1.037,1.037,0,1,0,2.011.5l.581-2.324H8.691Zm-3.108-4.4.722-2.889a.3.3,0,0,1,.565,0l.722,2.889Z",
    transform: "translate(-3.022 -2)",
    fill: "#ddd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.44e0493b6cde5dd6b4ee440b9085ab05.svg";
export { ForwardRef as ReactComponent };